// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 443 ? "about" : chunkId) + "-legacy." + {"250":"1b794a5a","443":"a064b4aa","451":"d4e44b29","600":"9e16fd0d","837":"8fdc6b42","839":"57186546","956":"9ddf26b1"}[chunkId] + ".js";
};